import StepProductData          from "./step-product-data.vue";
import StepProductWarranty      from "./step-product-warranty.vue";
import StepProductDefect        from "./step-product-defect.vue";
import StepProductReplacement   from "./step-product-replacement.vue";
import StepProductCustomerData  from "./step-product-customer-data.vue";
import StepProductSummary       from "./step-product-summary.vue";

export default {
    components : {
        StepProductData,
        StepProductWarranty,
        StepProductDefect,
        StepProductReplacement,
        StepProductCustomerData,
        StepProductSummary
    },
    data () {
        return {
            //DEBUG
            jsonDebug : false,
            get developerModus() {
                if (localStorage.getItem('userDeveloperModus') == 'true') {
                    return true;
                } else {
                    return false;
                }
            },
            set developerModus(value) {
                return;
            },

            //stepper
            stepper                 : 0,
            confirmDataDialog       : false,
            //model definition
            stepProductData         : null, //01
            stepProductWarranty     : null, //02
            stepProductDefect       : null, //03
            stepProductReplacement  : null, //04
            stepCustomerData        : null, //05
            stepOrderSummary        : null, //06

            stepProductDataHasErrors         : false, //01
            stepProductWarrantyHasErrors     : false, //02
            stepProductDefectHasErrors       : false, //03
            stepProductReplacementHasErrors  : false, //04
            stepCustomerDataHasErrors        : false, //05
            stepOrderSummaryHasErrors        : false, //06

            stepProductDataEditable          : false, //01
            stepProductWarrantyEditable      : false, //02
            stepProductDefectEditable        : false, //03
            stepProductReplacementEditable   : false, //04
            stepCustomerDataEditable         : false, //05
            stepOrderSummaryEditable         : false, //06
            // stepOrderSummaryEditable         : true, //06

            orderComplete                    : false,
            orderCompleteOverlay             : false,

            summaryData                     : null,
            collectStepsDataOverlay         : false,

            selectedProductInfos            : null
        };
    },
    watch: {
        orderCompleteOverlay (val) {
            console.info('vaaaaaaal', val);
            val && setTimeout(() => {
                this.orderCompleteOverlay = false;
            }, 3000);
        },
        collectStepsDataOverlay (val) {
            console.info('vaaaaaaal', val);
            val && setTimeout(() => {
                this.collectStepsDataOverlay = false;
            }, 1000);
        },
    },
    methods: {
        onCompleteOrderCreateNewClick() {
            this.stepOrderSummaryEditable = false;
            this.orderCompleteOverlay     = true;
            setTimeout(() => {
                var location = this.$route.fullPath;
                this.$router.replace('/');
                this.$nextTick(() => this.$router.replace(location));
            }, 3000);
        },
        onCompleteOrderClick() {
            this.stepOrderSummaryEditable = false;
            this.orderComplete            = true;
            this.orderCompleteOverlay     = true;
            let submitData = this.getStepsSubmitData();
            setTimeout(() => {
                console.info('submitData', submitData);
            }, 3000);
        },
        onDownloadOrderDataClick() {
            this.stepOrderSummaryEditable = false;
            this.orderComplete            = true;
            this.orderCompleteOverlay     = true;
            let submitData = this.getStepsSubmitData();
            setTimeout(() => {
                console.info('submitData', submitData);
                this.downloadData(submitData, 'orderData.json');
            }, 3000);
        },
        downloadData(data, fileName) {
            let a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            let json = JSON.stringify(data),
            blob = new Blob([json], {type: "octet/stream"}),
            url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = fileName;
            a.click();
        },
        validateStepProductData () {
            if(this.$refs.stepProductData.validateSelectedProduct()) {
                console.info('true');
                if(this.$refs.stepProductData.validateAll()) {
                    this.stepProductDataEditable = true;
                    this.stepper = 2;
                }
            }
        },
        validateStepProductWarranty() {
            console.info('validateStepProductWarranty');
            // this.summaryData = this.getStepsData();
            if(this.$refs.stepProductWarranty.validateAll()) {
                this.stepProductWarrantyEditable = true;
                this.stepper = 3;
            }
        },
        validateStepProductDefect() {
            let warrantyDecisionCases = this.getWarrantyDecisionCases();
            console.info('click on validate step 03 on order create', warrantyDecisionCases);
            if(this.$refs.stepProductDefect.validateAll()) {
                if (warrantyDecisionCases.businessCode == 0 || warrantyDecisionCases.businessCode == 1) {
                    this.stepper = 4;
                    this.stepProductDefectEditable = true;
                } else {
                    this.stepProductDefectEditable = false;
                    this.stepper = 5;
                }
            }

        },
        validateStepProductReplacement () {
            if(this.$refs.stepProductReplacement.isProductReplacementEnable()) {
                if(this.$refs.stepProductReplacement.validateSelectedProduct()) {
                    console.info('true');
                    if(this.$refs.stepProductReplacement.validateAll()) {
                        this.stepProductReplacementEditable = true;
                        this.stepper = 5;
                    }
                }
            } else {
                this.stepProductReplacementEditable = true;
                this.stepper = 5;

            }
        },
        validateStepCustomerData() {
            console.info('validateStepCustomerData');
            console.log('--->', this.$refs.stepProductCustomerData.validateAll());
            if(this.$refs.stepProductCustomerData.validateAll()) {
                this.summaryData = this.getStepsData();
                this.stepper = 6;
            }
        },
        getStepsData() {
            console.info('-- create order -- : getStepsData', this);
            this.collectStepsDataOverlay = true;
            let ret = {};
            ret.stepProductData         = this.$refs.stepProductData.getStepData();
            ret.stepProductWarranty     = this.$refs.stepProductWarranty.getStepData();
            ret.stepProductDefect       = this.$refs.stepProductDefect.getStepData();
            ret.stepProductReplacement  = this.$refs.stepProductReplacement.getStepData();
            ret.stepProductCustomerData        = this.$refs.stepProductCustomerData.getStepData();
            console.info('getStepsData - ret', ret);
            return ret;
        },
        getStepsSubmitData() {
            console.info('-- create order -- : getStepsSubmitData', this);
            let ret = {};
            ret.originalDevice      = this.$refs.stepProductData.getStepSubmitData();
            ret.warranty            = this.$refs.stepProductWarranty.getStepSubmitData();
            ret.defect              = this.$refs.stepProductDefect.getStepSubmitData();
            ret.replacementDevice   = this.$refs.stepProductReplacement.getStepData();
            ret.addresses           = this.$refs.stepProductCustomerData.getStepSubmitData();
            ret.summary             = this.$refs.StepProductSummary.getStepSubmitData();
            return ret;
        },
        onSelectedProductChange(selectedProduct) {
            console.warn('selectedProduct createjs', selectedProduct);
            this.selectedProductInfos = selectedProduct;
        },
        getWarrantyDecisionCases() {
            console.error(this.$refs);
            if(this.$refs.stepProductWarranty) {
                return this.$refs.stepProductWarranty.getWarrantyDecisionCases();
            }
        }
    },
    created() {
        console.info('this on create', this);
    }
};
